import React from 'react';
import { Box, Card, Divider, Stack, Typography } from '@mui/material';

interface SectionCardProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  /** Drop the inner padding when the body is a table that should reach the edges. */
  flush?: boolean;
  children: React.ReactNode;
}

/** A titled panel. The header/divider/body rhythm is identical everywhere. */
export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  action,
  flush = false,
  children,
}) => (
  <Card sx={{ overflow: 'hidden' }}>
    {(title || action) && (
      <>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 2.5, py: 2 }}
        >
          <Box sx={{ minWidth: 0 }}>
            {title && (
              <Typography variant="h6" component="h2">
                {title}
              </Typography>
            )}
            {description && (
              <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25 }}>
                {description}
              </Typography>
            )}
          </Box>
          {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
        </Stack>
        <Divider />
      </>
    )}
    <Box sx={flush ? undefined : { p: 2.5 }}>{children}</Box>
  </Card>
);

export default SectionCard;
